import { defineStore } from "pinia";
import { ref } from "vue";

export const useAlertStore = defineStore("alert", () => {
  const alerts = ref([]);

  const addAlert = (message, type = "error") => {
    const id = Date.now();
    alerts.value.push({ id, message, type });
    setTimeout(() => {
      removeAlert(id);
    }, 10000);
  };

  const removeAlert = (id) => {
    alerts.value = alerts.value.filter((alert) => alert.id !== id);
  };

  const clearAlerts = () => {
    alerts.value = [];
  };

  return {
    alerts,
    addAlert,
    removeAlert,
    clearAlerts,
  };
});
